/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
/**
 *
 * @export
 * @interface CsvPostAssertErrorResponse
 */
export interface CsvPostAssertErrorResponse {
  /**
   * A display string for the error
   * @type {string}
   * @memberof CsvPostAssertErrorResponse
   */
  error: string;
  /**
   * HTTP status code in the body
   * @type {number}
   * @memberof CsvPostAssertErrorResponse
   */
  status?: number;
  /**
   * enum error type string to make a condition on
   * @type {string}
   * @memberof CsvPostAssertErrorResponse
   */
  type: CsvPostAssertErrorResponseTypeEnum;
}

/**
 * @export
 */
export const CsvPostAssertErrorResponseTypeEnum = {
  CsvEmpty: 'csv_empty',
  PhoneColumnRequired: 'phone_column_required',
} as const;
export type CsvPostAssertErrorResponseTypeEnum =
  (typeof CsvPostAssertErrorResponseTypeEnum)[keyof typeof CsvPostAssertErrorResponseTypeEnum];

/**
 * Check if a given object implements the CsvPostAssertErrorResponse interface.
 */
export function instanceOfCsvPostAssertErrorResponse(
  value: object,
): value is CsvPostAssertErrorResponse {
  if (!('error' in value) || value['error'] === undefined) return false;
  if (!('type' in value) || value['type'] === undefined) return false;
  return true;
}

export function CsvPostAssertErrorResponseFromJSON(
  json: any,
): CsvPostAssertErrorResponse {
  return CsvPostAssertErrorResponseFromJSONTyped(json, false);
}

export function CsvPostAssertErrorResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CsvPostAssertErrorResponse {
  if (json == null) {
    return json;
  }
  return {
    error: json['error'],
    status: json['status'] == null ? undefined : json['status'],
    type: json['type'],
  };
}

export function CsvPostAssertErrorResponseToJSON(
  value?: CsvPostAssertErrorResponse | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    error: value['error'],
    status: value['status'],
    type: value['type'],
  };
}
